
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";

export interface JobFiltersProps {
  filters: { status: string; searchTerm: string };
  onFilterChange: (type: string, value: string) => void;
  onViewModeChange: (viewMode: 'table' | 'grid') => void;
  currentViewMode: 'table' | 'grid';
}

export const JobFilters: React.FC<JobFiltersProps> = ({ filters, onFilterChange, onViewModeChange, currentViewMode }) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between space-y-2 md:space-y-0 md:space-x-4">
      <div className="flex items-center space-x-2">
        <Label htmlFor="searchTerm">Search:</Label>
        <Input
          type="text"
          id="searchTerm"
          placeholder="Search by title, company, or client"
          value={filters.searchTerm}
          onChange={(e) => onFilterChange('searchTerm', e.target.value)}
          className="w-full md:w-auto"
        />
      </div>

      <div className="flex items-center space-x-2">
        <Label htmlFor="status">Status:</Label>
        <Select value={filters.status} onValueChange={(value) => onFilterChange('status', value)}>
          <SelectTrigger className="w-full md:w-[180px]">
            <SelectValue placeholder="All" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="open">Open</SelectItem>
            <SelectItem value="closed">Closed</SelectItem>
            <SelectItem value="on-hold">On Hold</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center space-x-2">
        <Label>View Mode:</Label>
        <div className="flex space-x-2">
          <Button
            variant={currentViewMode === 'table' ? 'default' : 'outline'}
            onClick={() => onViewModeChange('table')}
          >
            Table
          </Button>
          <Button
            variant={currentViewMode === 'grid' ? 'default' : 'outline'}
            onClick={() => onViewModeChange('grid')}
          >
            Grid
          </Button>
        </div>
      </div>
    </div>
  );
};
